if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.onSlideChanged = this.onSlideChanged.bind(this);
        this.addEventListener('keydown', (event) => {
          if (event.target !== this.viewer?.slider || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const last = this.viewer.sliderItemsToShow.length - 1;
          let index = this.viewer.currentPage - 1 + (event.key === 'ArrowLeft' ? -1 : 1);
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = last;
          const slide = this.viewer.sliderItemsToShow[Math.max(0, Math.min(index, last))];
          if (slide) this.viewer.setSlidePosition(slide.offsetLeft);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        const viewer = this.querySelector('slider-component');
        if (this.viewer !== viewer) {
          this.viewer?.removeEventListener('slideChanged', this.onSlideChanged);
          this.viewer = viewer;
          this.viewer.addEventListener('slideChanged', this.onSlideChanged);
        }
        super.show(opener);
        this.showActiveMedia();
        trapFocus(this, this.querySelector('[id^="ModalClose-"]'));
      }

      showActiveMedia() {
        this.viewer.resetPages();
        const activeMedia =
          this.viewer.querySelector(`[data-modal-media-id="${this.openedBy.dataset.mediaId}"]`) ||
          this.viewer.sliderItemsToShow[0];
        if (!activeMedia) return;
        this.viewer.slider.scrollTo({ left: activeMedia.offsetLeft, behavior: 'instant' });
        this.viewer.update();
        this.setActiveMedia(activeMedia);

        const deferredMedia = activeMedia.querySelector('deferred-media');
        if (deferredMedia?.querySelector('template')?.content.querySelector('.js-youtube')) {
          deferredMedia.loadContent(false);
        }
      }

      onSlideChanged(event) {
        if (this.hasAttribute('open')) this.setActiveMedia(event.detail.currentElement);
      }

      setActiveMedia(activeMedia) {
        if (!activeMedia) return;
        if (this.activeMedia !== activeMedia) {
          window.pauseAllMedia();
          if (this.activeMedia?.contains(document.activeElement)) this.viewer.slider.focus({ preventScroll: true });
          this.activeMedia = activeMedia;
        }
        this.viewer.sliderItems.forEach((slide) => {
          slide.inert = slide !== activeMedia;
          slide.setAttribute('aria-hidden', slide !== activeMedia);
        });
        this.querySelector('[data-modal-status]').textContent =
          `${this.viewer.currentPage} ${this.viewer.pagination.dataset.labelOf} ${this.viewer.sliderItemsToShow.length}`;
      }
    }
  );
}
